import { showError } from "../../app/components/toast.js";
import { logError } from "./logger.js";

export function handleError(err, fallbackMessage = "Something went wrong.") {
	console.error("❌ handleError received:", err);
	let message = fallbackMessage;

	if (typeof err === "string") message = err;
	else if (err instanceof Error) message = err.message;
	else if (err?.message) message = err.message;
	else if (err?.data?.message) message = err.data.message;

	showError(message);
	logError(err);
}
